var render = function render(){var _vm=this,_c=_vm._self._c;return _c('donut-chart34-template',{attrs:{"board-ids":[349],"data-type":_vm.dataType,"field-code":"workplace-material","graph-id":74,"title":"(원료·제조물)안전·보건 확보 의무 현황","unit":"건","orientation":_vm.orientation}})
}
var staticRenderFns = []

export { render, staticRenderFns }